// extracted by mini-css-extract-plugin
export default {"favouriteIndicator":"boIB_Hm6"};